module.exports = __webpack_public_path__ + "static/media/Facebook.7e2cd3a6.svg";